import Empty from '@components/empty/index.vue'
import CommonEmpty from '@components/empty/common_empty.vue'
import SearchEmpty from '@components/empty/search_empty.vue'
import FixedBottom from '@components/fixedBottom/index.vue'
import ImgHzw from '@components/imgHzw/index.vue'
import priceText from '@components/priceText/index.vue'
import titleBar from '@components/titleBar/index.vue'

export function install(Vue: Vue.VueConstructor) {
  Vue.component('FixedBottom', FixedBottom)
  Vue.component('Empty', Empty)
  Vue.component('CommonEmpty', CommonEmpty)
  Vue.component('SearchEmpty', SearchEmpty)
  Vue.component('ImgHzw', ImgHzw)
  Vue.component('PriceText', priceText)
  Vue.component('TitleBar', titleBar)
}
